import type { FC } from 'react';

export const BasketIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 6.66667L12.343 11.6184C12.2208 12.2293 12.1597 12.5347 12.0003 12.7632C11.8596 12.9647 11.666 13.1233 11.4409 13.2217C11.1855 13.3333 10.8741 13.3333 10.2511 13.3333H5.74891C5.12593 13.3333 4.81444 13.3333 4.55913 13.2217C4.33398 13.1233 4.1404 12.9647 3.99976 12.7632C3.84027 12.5347 3.77919 12.2293 3.65701 11.6184L2.66667 6.66667M13.3333 6.66667H12M13.3333 6.66667H14M2.66667 6.66667H2M2.66667 6.66667H4M12 6.66667H4M12 6.66667L10 2.66667M4 6.66667L6 2.66667M6 8.66667V10.6667M8 8.66667V10.6667M10 8.66667V10.6667"
      stroke={props.color || '#E6E6E9'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
